<template>
	<PopupRouterViewApprovalDetail label="Stock Adjustment Input"
		@approveMethod="submitAction" 
		:showApproveButton="isAllowSubmit" 
		approveButtonTitle="Submit Request" 
		approveButtonVariant="success"
		@rejectMethod="saveDraftAction" 
		:showRejectButton="isAllowSaveDraft" 
		rejectButtonTitle="Save As Draft" 
		rejectButtonVariant="danger"
		:showRevisionButton="false" 
		:showApprovalHistoryButton="false"
		:showLeftIcon="true"
		:isBusy="isBusy"
		@onHideMethod="onHidden"
	>

        <b-card header="Stock Adjustment" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<!-- <app-label label-cols-lg="12" size="sm" type="generatednumber" label="Stock Adjustment Number" :model="model.stockAdjustmentNumber" /> -->
						<app-input-datepicker  id="fieldset-stock-adjustment-date" label-cols-lg="12"  label="Stock Adjustment Date" size="sm" :model.sync="model.stockAdjustmentDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isUpdatable ="null" :isRequired="true"/>
						<app-input-combobox-autocomplete :options="stockAdjustmentTypes" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Adjustment Type" id="fieldset-stock-adjustment-type" size="sm" :model.sync="model.stockAdjustmentTypeId"   :selected="model.stockAdjustmentType != null ? model.stockAdjustmentType.name : ''" @input="getStockAdjustmentTypes" @change="updateData" :isUpdatable ="null" :isRequired="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockAdjustmentType" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Stock Adjustment Detail"
			:bordered="true" :items="stockAdjustmentDetails" 
			:fields="fieldsStockAdjustmentDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByStockAdjustmentDetail" 
			:sort-desc.sync="sortDescStockAdjustmentDetail" small responsive	
			@editButtonMethod="editRowDataStockAdjustmentDetail"	
			@deleteButtonMethod="deleteRowDataStockAdjustmentDetail"	
			@showPopupAddMethod="addDataStockAdjustmentDetail()"	
			@showPopupUploadMethod="showPopupUploadStockAdjustmentDetail()"
			@downloadMethod="downloadStockAdjustmentDetail()"
			@addFromClipboardMethod="addFromClipboardStockAdjustmentDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardStockAdjustmentDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadStockAdjustmentDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowStockAdjustmentDetailFilter = !isShowStockAdjustmentDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowStockAdjustmentDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Control Card">
					<v-select id="input-stock-adjustment-detail-control-card-table" append-to-body label="controlCardNumber" :options="controlCards" :value="filterStockAdjustmentDetail.controlCardId" :reduce="item => item.id" v-model="filterStockAdjustmentDetail.controlCardId" @search="getControlCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-stock-adjustment-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterStockAdjustmentDetail.partId" :reduce="item => item.id" v-model="filterStockAdjustmentDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Sistem">
					<b-form-input id="input-stock-adjustment-detail-qty-sytem-table" v-model="filterStockAdjustmentDetail.qtySytem" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Adjustment">
					<b-form-input id="input-stock-adjustment-detail-qty-adjustment-table" v-model="filterStockAdjustmentDetail.qtyAdjustment" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty After">
					<b-form-input id="input-stock-adjustment-detail-qty-after-table" v-model="filterStockAdjustmentDetail.qtyAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Reason">
					<b-form-input id="input-stock-adjustment-detail-reason-table" v-model="filterStockAdjustmentDetail.reason" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Control Card Status Before ">
					<v-select id="input-stock-adjustment-detail-control-card-status-before-table" append-to-body label="name" :options="controlCardStatuss" :value="filterStockAdjustmentDetail.controlCardStatusBeforeId" :reduce="item => item.id" v-model="filterStockAdjustmentDetail.controlCardStatusBeforeId" @search="getControlCardStatuss" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( stockAdjustmentDetailPageSize * (currentStockAdjustmentDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-stock-adjustment-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  @change="saveControlCard(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading" :isUpdatable ="null"  :nolabel="true" />	
			</template>
			<template v-slot:cell(part)="row">
				<app-label label-cols-lg="12" size="sm" label="Part Number" :model="row.item.part != null ? row.item.part.partNumber : ''"  />
			</template>
			<template v-slot:cell(qtySytem)="row">
				<app-input-textbox :id="'input-stock-adjustment-detail-qty-sytem-' + row.index" label-cols-lg="12" label="Qty Sistem" size="sm" :model.sync="row.item.qtySytem"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable ="null" :isEditable="false" :nolabel="true" type="number" />
			</template>
			<template v-slot:cell(qtyAdjustment)="row">
				<app-input-textbox :id="'input-stock-adjustment-detail-qty-adjustment-' + row.index" label-cols-lg="12" label="Qty Adjustment" size="sm" :model.sync="row.item.qtyAdjustment" :state="validateState('qtyAdjustment')" :errorMessage="getErrorMessage(errorMessage.qtyAdjustment, 'qtyAdjustment')" @keyupMethod="recalculate(row.item)" :isUpdatable ="null"  :nolabel="true" type="number" />
			</template>
			<template v-slot:cell(qtyAfter)="row">
				<app-input-textbox :id="'input-stock-adjustment-detail-qty-after-' + row.index" label-cols-lg="12" label="Qty After" size="sm" :model.sync="row.item.qtyAfter"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="null" :isEditable="false" :nolabel="true" type="number" />
			</template>
			<template v-slot:cell(supplierCaseNumberGr)="row">
				<app-input-textbox :id="'input-stock-adjustment-detail-supplier-case-number-gr-' + row.index" label-cols-lg="12" label="Supplier Case Number GR" size="sm" :model.sync="row.item.supplierCaseNumberGr"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="null" :isEditable="true" :nolabel="true" />
			</template>
			<template v-slot:cell(reason)="row">
				<app-input-textarea :id="'input-stock-adjustment-detail-reason-' + row.index" label-cols-lg="12" label="Reason" size="sm" :model.sync="row.item.reason" :state="validateState('reason')" :errorMessage="getErrorMessage(errorMessage.reason, 'reason')"  @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<!-- <template v-slot:cell(controlCardStatusBefore)="row">
				<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" :id="'input-stock-adjustment-detail-control-card-status-before-' + row.index" label-cols-lg="12" label="Control Card Status Before " size="sm" :model.sync="row.item.controlCardStatusBeforeId"  @change="saveInputStockAdjustmentDetail(row.item)" :selected="row.item.controlCardStatusBefore != null ? row.item.controlCardStatusBefore.name : ''"  @input="getControlCardStatuss" :loading="isControlCardStatusComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template> -->

								
			<template v-slot:form-add-detail>
				<StockAdjustmentDetailInput 
					:model="modelStockAdjustmentDetail"
					:openPopup="isShowPopupStockAdjustmentDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataStockAdjustmentDetail"/>
			</template>
			<template v-slot:upload-detail>
					<StockAdjustmentDetailUpload
					:openPopup="isShowPopupUploadStockAdjustmentDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataStockAdjustmentDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentStockAdjustmentDetailPage"
				:total-rows="totalStockAdjustmentDetailRow"
				:per-page="stockAdjustmentDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>

		<template #modal-left-button v-if="this.model.statusId === 'REQUEST FOR REVISION' || this.model.mainRecordId != null">
			<b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="float-right mr-2"
              >
				<b-button @click="resubmitAction()" size="sm" class="float-right btn-default">
				Resubmit Request
				</b-button>
			</b-overlay>
        </template>

	<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewApprovalDetail>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import StockAdjustment from '@/models/StockAdjustment/StockAdjustment';
import StockAdjustmentList from '@/models/StockAdjustment/StockAdjustmentList';
import StockAdjustmentFilter from '@/filters/StockAdjustment/StockAdjustmentFilter';

import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StockAdjustmentType from '@/models/StockAdjustmentType/StockAdjustmentType';
import StockAdjustmentTypeFilter from '@/filters/StockAdjustmentType/StockAdjustmentTypeFilter';
import StockAdjustmentDetail from '@/models/StockAdjustment/StockAdjustmentDetail';
import StockAdjustmentDetailFilter from '@/filters/StockAdjustment/StockAdjustmentDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import StockAdjustmentDetailInput from '@/views/StockAdjustment/StockAdjustmentDetailInput';
import StockAdjustmentDetailUpload from '@/views/StockAdjustment/StockAdjustmentDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import QcStatus from '@/models/QcStatus/QcStatus';
import QcStatusFilter from '@/filters/QcStatus/QcStatusFilter';
import PartGoodReceiptCase from '@/models/PartGoodReceipt/PartGoodReceiptCase';
import PartGoodReceiptCaseFilter from '@/filters/PartGoodReceipt/PartGoodReceiptCaseFilter';
export default {
	components : {
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		StockAdjustmentDetailInput,StockAdjustmentDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsStockAdjustmentDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"qtySytem": { "class" : "th-qty-sytem last-child", "label" : "Qty Sistem", key: 'qtySytem', sortable: false}}, 
				{"qtyAdjustment": { "class" : "th-qty-adjustment d-stack-none", "label" : "Qty Adjustment", key: 'qtyAdjustment', sortable: false}}, 
				{"qtyAfter": { "class" : "th-qty-after d-stack-none", "label" : "Qty After", key: 'qtyAfter', sortable: false}}, 
				{"supplierCaseNumberGr": { "class" : "th-supplier-case-number-gr d-stack-none", "label" : "Supplier Case Number GR", key: 'supplierCaseNumberGr', sortable: false}}, 
				{"reason": { "class" : "th-reason d-stack-none", "label" : "Reason", key: 'reason', sortable: false}}, 
				// {"controlCardStatusBefore": { "class" : "th-control-card-status-before d-stack-none", "label" : "Control Card Status Before ", key: 'controlCardStatusBefore', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelStockAdjustmentDetail : {},
			isShowPopupStockAdjustmentDetail : false,
			isShowPopupUploadStockAdjustmentDetail : false,
			filterStockAdjustment : null,
			currentStockAdjustmentPage : 1,
			stockAdjustmentPageSize: 10,
			sortByStockAdjustment: '',
			sortDescStockAdjustment: '',
			filterStockAdjustmentDetail : null,
			currentStockAdjustmentDetailPage : 1,
			stockAdjustmentDetailPageSize: 10,
			sortByStockAdjustmentDetail: '',
			sortDescStockAdjustmentDetail: '',
			sortingByStockAdjustmentDetail: [],
			stockAdjustmentDetails : [],
			stockAdjustmentDetailId : '',
			totalStockAdjustmentDetailRow : 0,
			isShowStockAdjustmentDetailFilter: false,
			isDownloadStockAdjustmentDetail: false,
			controlCards: [],
			parts: [],
			controlCardStatuss: [],
			stockAdjustmentTypes: [],
			isStockAdjustmentTypeComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			isStockAdjustmentComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			isControlCardStatusComboLoading: false,
			qcStatuses: [],
			operation: 'ADD',
		}
	},
	methods : {
		getSupplierCaseNumber: async function(item) {
			let filter = new PartGoodReceiptCaseFilter();
			filter.controlCardId = item.controlCardId;
			
			await PartGoodReceiptCase.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					console.log(result);
					item.supplierCaseNumberGr = result.data[0].supplierCaseNumber
				}
			})
			.catch(error => {});
		}, 
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				StockAdjustment.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'stockadjustmentinbox' });
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		recalculate(item) {
			if (this.model.stockAdjustmentType.code == 'ADD') {
				item.qtyAfter = parseFloat(item.qtySytem) + parseFloat(item.qtyAdjustment);
			}else {
				item.qtyAfter = parseFloat(item.qtySytem) - parseFloat(item.qtyAdjustment);
			}
			this.saveInputStockAdjustmentDetail(item);
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getStockAdjustment : async function(id) {
			this.isBusy = true;
			StockAdjustment.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				if (result != null) {
					if (this.model.stockAdjustmentTypeId == null || this.model.stockAdjustmentType == null) {
						this.getStockAdjustmentType();
					} 
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadStockAdjustment = true;
			this.filterStockAdjustment.id = this.modelId;
			StockAdjustment.downloadDataDetail(this, this.filterStockAdjustment).then(result => {
				this.isDownloadStockAdjustment = false;
			}).catch(error => { this.isDownloadStockAdjustment = false; })
		},
		getStockAdjustmentDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterStockAdjustmentDetail);
			if (this.modelId == null) return;
			filter.stockAdjustmentId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByStockAdjustmentDetail != null) {
				this.sortingByStockAdjustmentDetail[this.sortByStockAdjustmentDetail] = this.sortDescStockAdjustmentDetail;
			}
			let currentPage = (this.currentStockAdjustmentDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalStockAdjustmentDetailRow + 1;
				let page = Math.ceil(totalData/this.stockAdjustmentDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.stockAdjustmentDetailPageSize = 0;
			// disable paging end
			StockAdjustmentDetail.getList(this, filter, this.sortingByStockAdjustmentDetail, currentPage , this.stockAdjustmentDetailPageSize).then(result => {
				this.currentStockAdjustmentDetailPage = currentPage + 1;
				this.stockAdjustmentDetails = result.data;
				this.totalStockAdjustmentDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getStockAdjustments : async function(input) {
			let filter = new StockAdjustmentFilter();
			if (input != undefined) {
				filter.StockAdjustmentNumber = input;
			}
			this.isStockAdjustmentComboLoading = true;
			StockAdjustment.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockAdjustments = result.data;
					if (this.model.stockAdjustmentTypeId == null || this.model.stockAdjustmentType == null) {
						this.getStockAdjustmentType();
					} 
				}
				this.isStockAdjustmentComboLoading = false;
			})
			.catch(error => {});
		},
		// getStockAdjustments : async function(input) {
		// 	let filter = new StockAdjustmentFilter();
		// 	if (input != undefined) {
		// 		filter.stockAdjustmentNumber = input;
		// 	}
		// 	this.isStockAdjustmentComboLoading = true;
		// 	StockAdjustment.getList(this, filter, null, 0, 10)
		// 	.then(result => {
		// 		if (result != null) {
		// 			this.stockAdjustments = result.data
		// 		}
		// 		this.isStockAdjustmentComboLoading = false;
		// 	})
		// 	.catch(error => {});
		// },
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			//pilih semua qcstatus		
			if(this.qcStatuses.length > 0) {
				filter.qcStatusId = this.qcStatuses.map(e => e.id).join(',');
			}
			//filter.qcStatusId = this.qcStatus.id;

			//filter.controlCardStatusId = 'OK,UNCOMPLETE';
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getQcStatus : async function(input) {
			let filter = new QcStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			filter.code = 'OK,UNCOMPLETE';
			filter.exactType.code = 1;
			QcStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					console.log("qcStatus", result.data);
					this.qcStatuses = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isControlCardStatusComboLoading = true;
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
				this.isControlCardStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getStockAdjustmentTypes : async function(input) {
			let filter = new StockAdjustmentTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			StockAdjustmentType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockAdjustmentTypes = result.data
				}
			})
			.catch(error => {});
		},
		getStockAdjustmentType : async function(input) {
			let filter = new StockAdjustmentTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			filter.code = 'ADD';
			StockAdjustmentType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.model.stockAdjustmentType = result.data[0];
					this.model.stockAdjustmentTypeId = result.data[0].id;
				}
			})
			.catch(error => {});
		},
		setSelectedStockAdjustmentType(item) {
			if(item == undefined || item == null) {
				this.model.stockAdjustmentTypeId = null;
				this.model.stockAdjustmentType = null;
				this.operation = '';
			} else {
				this.model.stockAdjustmentTypeId = item.id;
				this.model.stockAdjustmentType = item;
				this.operation = item.code;
				if (this.stockAdjustmentDetails.length > 0) {
					this.stockAdjustmentDetails.forEach(data => {
						if ((data.qtySytem != undefined || data.qtySytem != null) && (data.qtyAdjustment != undefined || data.qtyAdjustment != null)) {
							this.recalculate(data);
						}
					});
				}
			}
			this.$forceUpdate();
			this.updateData();
		},
		async saveControlCard(item) {
			item.qtyAdjustment = null;
			item.qtyAfter = null;
			await this.getSupplierCaseNumber(item);
			await this.saveInputStockAdjustmentDetail(item);
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveAction(modalEvent) {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					model.statusId = 'DRAFT';
					StockAdjustment.updateData(this, model, id).then(result => {
						StockAdjustment.commitData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$router.push({ name: 'stockadjustmentinbox' });
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}).catch(error => { this.isBusy = false; });
				} else {
					model.statusId = 'DRAFT';
					StockAdjustment.insertData(this, model).then(result => {
						this.$router.push({ name: 'stockadjustmentinbox' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
		},
		saveDraftAction(modalEvent) {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					model.statusId = 'DRAFT';
					StockAdjustment.updateData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'stockadjustmentinbox' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					model.statusId = 'DRAFT';
					StockAdjustment.insertData(this, model).then(result => {
						this.$router.push({ name: 'stockadjustmentinbox' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
		},		
		submitAction(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					StockAdjustment.updateData(this, model, id).then(result => {
						StockAdjustment.submitApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$router.push({ name: 'stockadjustmentinbox' });
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}).catch(error => { this.isBusy = false; });
				} 
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockAdjustment.updateData(this, model, id)
					.catch((error) => {
						this.getStockAdjustment(id);
					});
				}
			});
		},
		onHidden() {
			let this_ = this;
			let id = this_.modelId;

			if (this_.model.mainRecordId != null) {
				return this_.$http.post('StockAdjustment/resetOnHidden/' + id)
				.then(async function (response) {
					return response.data;
				})
				.catch(function (error) {
					this_.$store.dispatch('addErrorMessageGlobal', error);
					throw error;
				});
			}
		},
		addRowDataStockAdjustmentDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.stockAdjustmentId =  this.modelId;
					StockAdjustmentDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getStockAdjustmentDetails(true);
						this.isShowPopupStockAdjustmentDetail = false;
					})
				} else {
					model.stockAdjustmentId =  this.modelId;
					StockAdjustmentDetail.createDataDetail(this, model)
					.then(result => {
						this.getStockAdjustmentDetails(true);
						this.isShowPopupStockAdjustmentDetail = false;
					})
				}
			}
		},
		async editRowDataStockAdjustmentDetail(id) {
			this.stockAdjustmentDetailId = id;
			this.isShowPopupStockAdjustmentDetail = true; 
		},
		async deleteRowDataStockAdjustmentDetail(id) {
			StockAdjustmentDetail.deleteData(this, id).then(result => { this.getStockAdjustmentDetails(); });
		},
		async resetDataStockAdjustmentDetail() {
			this.stockAdjustmentDetailId = "";
			this.isShowPopupStockAdjustmentDetail = true;
		},
		async addDataStockAdjustmentDetail() {
			StockAdjustmentDetail.createData(this, { stockAdjustmentId: this.modelId })
			.then(result => {
				this.getStockAdjustmentDetails(true);
			})
		},
		async addFromClipboardStockAdjustmentDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockAdjustmentId: this.modelId });
				});
				StockAdjustmentDetail.addFromClipboard(this, controlCards).then(result => { this.getStockAdjustmentDetails() });
			});
		},
		async replaceFromClipboardStockAdjustmentDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockAdjustmentId: this.modelId });
				});
				StockAdjustmentDetail.replaceFromClipboard(this, controlCards).then(result => { this.getStockAdjustmentDetails() });
			});   
		},
		showPopupUploadStockAdjustmentDetail() {
			if(this.stockAdjustmentDetails != null && this.stockAdjustmentDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap StockAdjustmentDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadStockAdjustmentDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadStockAdjustmentDetail = true;
			}
		},
		uploadDataStockAdjustmentDetail(modalEvent, newDatas) {
			this.isShowPopupUploadStockAdjustmentDetail = false; 
		},
		downloadStockAdjustmentDetail(modalEvent) {
			this.isDownloadStockAdjustmentDetail = true;
			this.filterStockAdjustmentDetail.stockAdjustmentId = this.modelId;
			StockAdjustmentDetail.downloadDataDetail(this, this.filterStockAdjustmentDetail).then(result => {
				this.isDownloadStockAdjustmentDetail = false;
			}).catch(error => { this.isDownloadStockAdjustmentDetail = false; })
		},
		saveInputStockAdjustmentDetail(item) {
			if (this.stockAdjustments != null && this.stockAdjustments != undefined  && this.stockAdjustments.length > 0) {
				item.stockAdjustment = this.stockAdjustments.find(q => q.id == item.stockAdjustmentId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				if (this.controlCards.find(q => q.id == item.controlCardId) != null) {
					item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
					item.controlCardId = item.controlCard.id;
					item.controlCardControlCardNumber = item.controlCard.controlCardNumber;
					item.qtySytem = item.controlCard.qtyCase;
					item.part = item.controlCard.part;
					item.partId = (item.controlCard.part != null) ? item.controlCard.part.id : '';
				}
			}
			// if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
			// 	item.part = this.parts.find(q => q.id == item.partId);
			// }
			if (this.controlCardStatuss != null && this.controlCardStatuss != undefined  && this.controlCardStatuss.length > 0) {
				item.controlCardStatusBefore = this.controlCardStatuss.find(q => q.id == item.controlCardStatusBeforeId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockAdjustmentDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadStockAdjustmentDetail = false; 
			this.isShowPopupStockAdjustmentDetail = false; 
			if (modalType == 'StockAdjustmentDetail') {
				this.getStockAdjustmentDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowStockAdjustmentDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterStockAdjustment = new StockAdjustmentFilter();
		this.filterStockAdjustmentDetail = new StockAdjustmentDetailFilter();
		//this.getStockAdjustments();
		//this.getControlCards();
		//this.getParts();
		//this.getControlCardStatuss();
		//this.getStockAdjustmentTypes();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getStockAdjustment(id);
			} else {
				this.modelId = id;
				this.getStockAdjustment(id);
			}
		}
		this.getQcStatus();
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if (this.model.statusId === 'REQUEST FOR REVISION' || this.model.mainRecordId != null) return false;
				return true;
			}
		},
		isAllowSubmit: {
			get: function() {
				if (this.model.statusId === 'REQUEST FOR REVISION' || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByStockAdjustmentDetail : {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		sortDescStockAdjustmentDetail: {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		currentStockAdjustmentDetailPage: {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		stockAdjustmentDetailPageSize : {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		filterStockAdjustmentDetail: {
			handler: function() {
				this.getStockAdjustmentDetails();
			},
			deep: true,
		},
		stockAdjustmentDetails(newValues) {
			newValues.forEach(data => {
				if(this.operation == 'ADD') {
					data.qtyAfter = data.qtySytem + data.qtyAdjustment;
				}
				else if(this.operation == 'REDUCE') {
					data.qtyAfter = data.qtySytem - data.qtyAdjustment;
				}
			});

			this.stockAdjustmentDetails = newValues;
		}
	},
}
</script>
